import { Component, OnInit } from "@angular/core";
import { EventService } from "../../core/services/event.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { getSidebarSize } from "src/app/store/layouts/layout-selector";
import { RootReducerState } from "src/app/store";
import { Store } from "@ngrx/store";

@Component({
  selector: "app-vertical",
  templateUrl: "./vertical.component.html",
  styleUrls: ["./vertical.component.scss"],
  standalone: false
})
export class VerticalComponent implements OnInit {
  isCondensed = false;
  getsize: any;

  constructor(private eventService: EventService, private router: Router, private activatedRoute: ActivatedRoute, private store: Store<RootReducerState>) {}

  ngOnInit(): void {
    this.router.events.subscribe((event: any) => {
      if (document.documentElement.getAttribute("data-preloader") === "enable" && event instanceof NavigationEnd) {
        // Update the attribute state based on the current route or any other conditions
        const preloader = document.getElementById("preloader") as HTMLElement;
        if (preloader) {
          if (event.url !== "/disabled-route") {
            preloader.style.opacity = "1";
            preloader.style.visibility = "";
            setTimeout(() => {
              preloader.style.opacity = "0";
              preloader.style.visibility = "hidden";
            }, 1000);
          } else {
            preloader.style.opacity = "0";
            preloader.style.visibility = "hidden";
          }
        }
      }
    });

    this.handlePreloader(this.activatedRoute.snapshot.routeConfig?.path);
    if (document.documentElement.getAttribute("data-sidebar-size") === "lg") {
      this.store.select(getSidebarSize).subscribe((size) => {
        this.getsize = size;
      });
      window.addEventListener("resize", () => {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        if (document.documentElement.clientWidth <= 767) {
          document.documentElement.setAttribute("data-sidebar-size", "");
          document.querySelector(".hamburger-icon")?.classList.add("open");
        } else if (document.documentElement.clientWidth <= 1024) {
          document.documentElement.setAttribute("data-sidebar-size", "sm");
          document.querySelector(".hamburger-icon")?.classList.add("open");
        } else if (document.documentElement.clientWidth >= 1024 && document.documentElement.getAttribute("data-layout-width") === "fluid") {
          document.documentElement.setAttribute("data-sidebar-size", self.getsize);
          document.querySelector(".hamburger-icon")?.classList.remove("open");
        }
      });
    }
  }
  private handlePreloader(route: any): void {
    const preloader = document.getElementById("preloader") as HTMLElement;
    if (preloader) {
      if (route !== "/disabled-route") {
        preloader.style.opacity = "1";
        preloader.style.visibility = "";
        setTimeout(() => {
          preloader.style.opacity = "0";
          preloader.style.visibility = "hidden";
        }, 1000);
      } else {
        preloader.style.opacity = "0";
        preloader.style.visibility = "hidden";
      }
    }
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu(): void {
    const sidebarSizeAttribute = "data-sidebar-size";
    const currentSidebarSize = document.documentElement.getAttribute(sidebarSizeAttribute);
    const clientWidth = document.documentElement.clientWidth;

    if (clientWidth >= 767) {
      const newSize = this.getNewSidebarSize(currentSidebarSize);
      document.documentElement.setAttribute(sidebarSizeAttribute, newSize);
    }

    if (clientWidth <= 767) {
      document.body.classList.toggle("vertical-sidebar-enable");
    }

    this.isCondensed = !this.isCondensed;
  }

  getNewSidebarSize(currentSize: string | null): string {
    switch (currentSize) {
      case "md":
        return currentSize === "md" ? "sm" : "md";
      case "sm":
        return "lg";
      default:
        return currentSize === "lg" ? "sm" : "lg";
    }
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked(): void {
    document.body.classList.toggle("right-bar-enabled");
    const rightBar = document.getElementById("theme-settings-offcanvas");
    if (rightBar !== null) {
      rightBar.classList.toggle("show");
      rightBar.setAttribute("style", "visibility: visible;");
    }
  }

  onResize(event: any): void {
    if (document.body.getAttribute("layout") === "twocolumn") {
      if (event.target.innerWidth <= 767) {
        this.eventService.broadcast("changeLayout", "vertical");
      } else {
        this.eventService.broadcast("changeLayout", "twocolumn");
        document.body.classList.remove("twocolumn-panel");
        document.body.classList.remove("vertical-sidebar-enable");
      }
    }
  }
}
